import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 32 32'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m11.2 22.205 4.8-4.8 4.8 4.8 1.405-1.405-4.8-4.8 4.8-4.8L20.8 9.795l-4.8 4.8-4.8-4.8L9.795 11.2l4.8 4.8-4.8 4.8zm4.802 6.462q-2.627 0-4.94-.998a12.8 12.8 0 0 1-4.023-2.707 12.8 12.8 0 0 1-2.708-4.02q-.998-2.312-.998-4.94t.998-4.94a12.8 12.8 0 0 1 2.707-4.023 12.8 12.8 0 0 1 4.02-2.708q2.312-.998 4.94-.998t4.94.998a12.8 12.8 0 0 1 4.023 2.707 12.8 12.8 0 0 1 2.708 4.02q.998 2.313.998 4.94t-.998 4.94a12.8 12.8 0 0 1-2.707 4.023 12.8 12.8 0 0 1-4.02 2.708q-2.312.998-4.94.998m-.002-2q4.467 0 7.567-3.1t3.1-7.567-3.1-7.567T16 5.333t-7.567 3.1T5.333 16t3.1 7.567q3.101 3.1 7.567 3.1'
    />
  </svg>
)
export default SvgComponent
